export default __webpack_public_path__ + "static/media/webView.9bfd1fcf.png";